'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _arrayify = require('helpers/arrayify');

var _arrayify2 = _interopRequireDefault(_arrayify);

var _AccordionItem = require('../AccordionItem');

var _AccordionItem2 = _interopRequireDefault(_AccordionItem);

var _Accordion = require('./Accordion.scss');

var _Accordion2 = _interopRequireDefault(_Accordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Accordion = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Accordion, _Component);

  function Accordion(props) {
    (0, _classCallCheck3.default)(this, Accordion);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Accordion.__proto__ || (0, _getPrototypeOf2.default)(Accordion)).call(this, props));

    _initialiseProps.call(_this);

    var activeItems = (0, _arrayify2.default)(props.activeItems);

    // can't have multiple active items, just use the first one
    if (!props.allowMultiple) activeItems = [activeItems[0]];

    _this.state = { activeItems: activeItems };
    return _this;
  }

  (0, _createClass3.default)(Accordion, [{
    key: '_renderItems',
    value: function _renderItems() {
      var _this2 = this;

      var activeItems = this.state.activeItems;
      var _props = this.props,
          children = _props.children,
          openNextAccordionItem = _props.openNextAccordionItem;

      if (!children) return null;

      var _children = (0, _arrayify2.default)(children);
      return _children.map(function (item, index) {
        var key = openNextAccordionItem ? index : item.props.slug || index;

        return _react2.default.cloneElement(item || Accordion.Item, {
          key: key,
          expanded: activeItems.includes(key),
          onClick: _this2._onClick.bind(_this2, key),
          ref: 'item-' + key,
          className: (0, _classnames2.default)(item.props.className, _Accordion2.default.item)
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          style = _props2.style;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, _Accordion2.default.root), role: 'tablist', style: style },
        this._renderItems()
      );
    }
  }]);
  return Accordion;
}(_react.Component), _class.Item = _AccordionItem2.default, _class.propTypes = {
  /* Allow multiple items to be open at the same time */
  allowMultiple: _react.PropTypes.bool,
  /* Opens the next accordion item after the previous one is closed.
  Defaults first one as active and applies for each accordion item except the last one.
  Not compatible when passing in a custom slug */
  openNextAccordionItem: _react.PropTypes.bool,
  /* Receives either an array of indexes or a single index.
  Each index corresponds to the item order, starting from 0.
  Ex: activeItems={0}, activeItems=[0, 1, 2] */
  activeItems: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.array]),
  /* Usually Accordion items, These ones will be rendered inside the Accordion */
  children: _react.PropTypes.node.isRequired,

  /* Triggered when component updates and passes new state as an argument */
  onChange: _react.PropTypes.func,

  /* Custom className applied to root div */
  className: _react.PropTypes.string,
  /* Inline styles applied to root div */
  style: _react.PropTypes.object
}, _class.defaultProps = {
  allowMultiple: false,
  openNextAccordionItem: false,
  activeItems: [0]
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this._onClick = function (index) {
    var activeItems = _this3.state.activeItems;
    var _props3 = _this3.props,
        children = _props3.children,
        openNextAccordionItem = _props3.openNextAccordionItem,
        allowMultiple = _props3.allowMultiple,
        onChange = _props3.onChange;

    var newState = {};

    // clone active items state array
    newState.activeItems = [].concat((0, _toConsumableArray3.default)(activeItems));

    var position = newState.activeItems.indexOf(index);

    if (position !== -1) {
      newState.activeItems.splice(position, 1);

      if (openNextAccordionItem && index !== children.length - 1) {
        newState.activeItems.push(index + 1);
      }
    } else if (allowMultiple) {
      newState.activeItems.push(index);
    } else {
      newState.activeItems = [index];
    }

    // removes duplicate items in activeItems array
    newState.activeItems = newState.activeItems.filter(function (itm, pos, arr) {
      return arr.indexOf(itm) === pos;
    });

    if (onChange) onChange(newState);
    _this3.setState(newState);
  };
}, _temp);
exports.default = Accordion;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseAccordion/Accordion/Accordion.jsx
// module id = 1578
// module chunks = 0